import {
  LocalUser,
  RemoteUser,
  useIsConnected,
  useJoin,
  useLocalMicrophoneTrack,
  useLocalCameraTrack,
  usePublish,
  useRemoteUsers,
  useRTCClient,
} from "agora-rtc-react";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./styles.css";
import { Button, message, Checkbox } from "antd";
import { ImPhoneHangUp } from "react-icons/im";
import { Container } from "react-bootstrap";
import { getToken } from "../../../redux/api/Token/GetTokenSlice";
import { getPathSegment } from "../../../utils/navigation";

export const Basics = () => {
  const dispatch = useDispatch();
  const [calling, setCalling] = useState(true);
  const [shouldJoin, setShouldJoin] = useState(false);
  const isConnected = useIsConnected();
  const [mode, setMode] = useState(getPathSegment(2));
  const [channel, setChannel] = useState(
    getPathSegment(3)
  );
  const [id, setId] = useState(getPathSegment(4));
  const [appId, setAppId] = useState("7338cf3deca7453f8ef37d8e7fdf5946");

  const [token, setToken] = useState(null);

  //local user
  const [micOn, setMic] = useState(true);
  const [cameraOn, setCamera] = useState(mode === "VIDEO" ? true : false);
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
  const { localCameraTrack } = useLocalCameraTrack(cameraOn);
  usePublish([localMicrophoneTrack, localCameraTrack]);
  const [checkedJoined, setCheckedJoined] = useState(false);
  //remote users
  const client = useRTCClient(); // Get the Agora client instance

  const remoteUsers = useRemoteUsers();

  const generateToken = () => {
    dispatch(getToken(id)).then((res) => {
      setToken(res.payload.message.payload);

      setCalling(true);

      return res.payload.message.payload;
    });
  };
  console.log("token", generateToken());
  useEffect(() => {
    if (token !== null) {
      generateToken();
    }
  });
  const { join, leave, isJoined } = useJoin(
    { appid: appId, channel: channel, token: token, uid: null },
    shouldJoin // Controls whether we should join the call
  );

  useEffect(() => {
    if (token) {
      setShouldJoin(true);
    }
  }, [token]);

  useEffect(() => {
    if (!client) return;

    const handleUserLeft = (user) => {
      console.log("Remote user left:", user.uid);

      alert(`Practitioner left the call.`);
      //window.location.href = "https://expert.phybercare.com/";
    };

    client.on("user-left", handleUserLeft);

    return () => {
      client.off("user-left", handleUserLeft);
    };
  }, [client]);

  return (
    <Container
      fluid
      style={{
        padding: 0,
        margin: 0,

        background: "black",
        height: "100vh",
      }}
    >
      <div className="room">
        {isConnected ? (
          <div>
            <div>
              {remoteUsers.length > 0 ? null : (
                <div
                  className="prescription-not-holder"
                  style={{ width: "80%", marginLeft: "10%", marginTop: 50 }}
                >
                  <Checkbox
                    checked={checkedJoined}
                    onChange={() => {
                      setCheckedJoined(!checkedJoined);
                      //closeCall();
                      //  window.location.href = "/studentVideo/1";
                      const message = {
                        action: "notjoined",
                        value: "Hello from React.js Web App",
                      };
                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify(message)
                        );
                      } else {
                        console.warn("ReactNativeWebView is not available");
                      }
                    }}
                  >
                    <span
                      style={{
                        color: "#FFFFFF",
                        fontSize: "12px",
                      }}
                    >
                      {"Practitioner Not Joined"}
                    </span>
                  </Checkbox>
                </div>
              )}
            </div>
            {remoteUsers.map((user) => (
              <Container className="local-user" key={user}>
                <RemoteUser
                  cover="https://expert.phybercare.com/favicon.png"
                  user={user}
                  allowFullScreen={false}
                >
                  <samp className="user-name">{user.uid}</samp>
                </RemoteUser>
              </Container>
            ))}
            {/* <Container className="remote-user">
              <LocalUser
                audioTrack={localMicrophoneTrack}
                cameraOn={cameraOn}
                micOn={micOn}
                videoTrack={localCameraTrack}
                allowFullScreen={false}
                cover="https://expert.phybercare.com/favicon.png"
              >
                <samp className="user-name">You</samp>
              </LocalUser>
            </Container> */}
          </div>
        ) : (
          <div className="join-room" style={{ display: "none" }}>
            <input
              onChange={(e) => setAppId(e.target.value)}
              placeholder="<Your app ID>"
              value={appId}
            />
            <input
              onChange={(e) => setChannel(e.target.value)}
              placeholder="<Your channel Name>"
              value={channel}
            />
            <input
              onChange={(e) => setToken(e.target.value)}
              placeholder="<Your token>"
              value={token}
            />

            <button
              className={`join-channel ${!appId || !channel ? "disabled" : ""}`}
              disabled={!appId || !channel}
              onClick={() => setCalling(true)}
            >
              <span>Join Channel</span>
            </button>
          </div>
        )}
      </div>
      {isConnected && (
        <Container
          style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            bottom: 0,
            zIndex: 1,
          }}
        >
          <Button
            className={`btn btn-phone ${calling ? "btn-phone-active" : ""}`}
            onClick={() => {
              setCalling((a) => !a);
              setShouldJoin(false);
              const message = {
                action: "endCall",
                value: "Hello from React.js Web App",
              };
              if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
              } else {
                console.warn("ReactNativeWebView is not available");
              }
            }}
          >
            {calling ? (
              <ImPhoneHangUp size={35} />
            ) : (
              <i className="i-mdi-phone" />
            )}
          </Button>
        </Container>
      )}
    </Container>
  );
};

export default Basics;
